import { BlogMetadata } from './BlogMetadata'
import { BlogMetadataV2 } from './BlogMetadataV2'
import { useBlogMetadataRecord } from 'hooks/queries/blogMedatadataRecords/useBlogMetadataRecord'
import { useFlipperFlag } from 'hooks/useFlipperFlag'

type Props = {
  articleId: string
}

export const BlogMetadataContainer = ({ articleId }: Props) => {
  const { data: blogMetadata } = useBlogMetadataRecord()
  const useBlogMetadataV2 = useFlipperFlag('blog_metadata_v2')

  if (useBlogMetadataV2) {
    return <BlogMetadataV2 articleId={articleId} initialData={blogMetadata} />
  }

  return <BlogMetadata articleId={articleId} initialData={blogMetadata} />
}
